import React from "react";
import ModalPortal from "../../../../components/ModalPortal";

/**
 * FeatureMappingModal - Modal for linking or creating a new scoped feature for a family
 */
const FeatureMappingModal = ({
    isOpen,
    onClose,
    onSubmit,
    selectedFamily,
    mappingFeatureType,
    setMappingFeatureType,
    newFeatureName,
    setNewFeatureName,
    selectedFeatureToLink,
    setSelectedFeatureToLink,
    featuresAvailableToLink,
    mappingSaving
}) => {
    if (!isOpen) return null;

    return (
        <ModalPortal>
        <div
            className="modal-overlay"
            onMouseDown={(e) => {
                if (e.target === e.currentTarget) {
                    const overlayMouseDown = { current: true };
                    e.currentTarget.addEventListener('mouseup', () => {
                        if (overlayMouseDown.current) onClose();
                    }, { once: true });
                }
            }}
        >
            <div className="modal-content" onClick={e => e.stopPropagation()} style={{ minWidth: '400px' }}>
                <h2 style={{ color: 'var(--text-primary)', margin: '0 0 1rem 0', fontSize: '1.25rem' }}>
                    Add Feature to {selectedFamily?.name}
                </h2>
                
                <div style={{ display: 'flex', gap: '1rem', borderBottom: '1px solid var(--border)', paddingBottom: '0.75rem', marginBottom: '1.25rem' }}>
                    <button
                        type="button"
                        onClick={() => setMappingFeatureType('link')}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            borderBottom: mappingFeatureType === 'link' ? '2px solid var(--text-primary)' : 'none',
                            color: mappingFeatureType === 'link' ? 'var(--text-primary)' : 'var(--text-secondary)',
                            fontWeight: 600,
                            paddingBottom: '0.25rem',
                            cursor: 'pointer'
                        }}
                    >
                        Link Existing Feature
                    </button>
                    <button
                        type="button"
                        onClick={() => setMappingFeatureType('create')}
                        style={{
                            background: 'transparent',
                            border: 'none',
                            borderBottom: mappingFeatureType === 'create' ? '2px solid var(--text-primary)' : 'none',
                            color: mappingFeatureType === 'create' ? 'var(--text-primary)' : 'var(--text-secondary)',
                            fontWeight: 600,
                            paddingBottom: '0.25rem',
                            cursor: 'pointer'
                        }}
                    >
                        Create New Feature
                    </button>
                </div>

                <form onSubmit={onSubmit} className="importer-form">
                    {mappingFeatureType === 'create' ? (
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600 }}>
                                Feature Variable Name
                            </label>
                            <input
                                className="input-field"
                                value={newFeatureName}
                                onChange={e => setNewFeatureName(e.target.value)}
                                required
                                placeholder="e.g. Engine.Displacement"
                                autoFocus
                            />
                            <span style={{ fontSize: '0.75rem', color: 'var(--text-secondary)', display: 'block', marginTop: '0.25rem' }}>
                                Will be initialized as a local feature mapped to this family.
                            </span>
                        </div>
                    ) : (
                        <div>
                            <label style={{ display: 'block', marginBottom: '0.5rem', fontSize: '0.9rem', fontWeight: 600 }}>
                                Select Feature
                            </label>
                            {featuresAvailableToLink.length === 0 ? (
                                <p style={{ fontSize: '0.85rem', color: 'var(--text-secondary)', margin: 0, fontStyle: 'italic' }}>
                                    No other unmapped local features available.
                                </p>
                            ) : (
                                <select
                                    className="input-field"
                                    value={selectedFeatureToLink}
                                    onChange={e => setSelectedFeatureToLink(e.target.value)}
                                    required
                                    autoFocus
                                >
                                    <option value="">-- Choose Feature --</option>
                                    {featuresAvailableToLink.map(f => (
                                        <option key={f.id} value={f.id}>{f.name}</option>
                                    ))}
                                </select>
                            )}
                        </div>
                    )}

                    <div className="modal-actions" style={{ marginTop: '1.5rem' }}>
                        <button type="button" className="btn-secondary" onClick={onClose}>
                            Cancel
                        </button>
                        <button
                            type="submit"
                            className="btn-primary"
                            disabled={mappingSaving || (mappingFeatureType === 'link' && featuresAvailableToLink.length === 0)}
                            style={{ background: 'var(--text-primary)', color: 'var(--bg-primary)' }}
                        >
                            {mappingSaving ? 'Saving...' : 'Add Feature'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
        </ModalPortal>
    );
};

export default FeatureMappingModal;
